import EmailTemplatesPage from '@/pages/email-templates/EmailTemplatesPage'
import ErrorBoundary from '@/components/layout/ErrorBoundary'

export const emailTemplateRoutes = [
  {
    path: '/email-templates',
    element: <EmailTemplatesPage />,
    errorElement: <ErrorBoundary />
  }
]
